export function getHostnameSubdomain(hostname = '') {
  return hostname.toLowerCase().split('.')[0] || '';
}

/**
 * play2.* → G, play.* → TikTok (play2 is checked first).
 */
export function getSubdomainPlatform(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const subdomain = getHostnameSubdomain(hostname);

  if (subdomain.startsWith('play2')) {
    return 'G';
  }
  if (subdomain.startsWith('play')) {
    return 'TikTok';
  }

  return null;
}

export function isQuickLoginSubdomain(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const subdomain = getHostnameSubdomain(hostname);
  return subdomain.startsWith('play2') || subdomain.startsWith('play');
}

export function resolveUserPlatform({ query = {} } = {}) {
  const fromQuery = query.ref || query.referrer;
  if (fromQuery) {
    return fromQuery;
  }

  const fromSubdomain = getSubdomainPlatform();
  if (fromSubdomain) {
    return fromSubdomain;
  }

  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('user_platform_ref');
  }

  return null;
}
